/**
 * @param {Response} response
 *
 * @return {Response}
 * @throws {Error}    In case of HTTP status code >= 400
 */
export default function handleError(response) {
  if (!response.ok) {
    // We would ideally have used a proper custom error class,
    // but this would require using a specific Babel plugin,
    // which would in turn require using Babel itself. So no.
    // @see https://github.com/babel/babel/issues/4058
    const error = new Error(response.statusText);

    error.response = response;
    error.isUnauthorized = () => response.status === 401;

    throw error;
  }

  return response;
}
